import axios from "axios";

const API_BASE = "/api/v1/finance/budget";

export const FinanceBudgetService = {
  checkPermission: userName =>
    axios.get(`${API_BASE}/check-permission`, { params: { userName } }),

  // Master data lookups
  getYears: () => axios.get(`${API_BASE}/master/years`),
  getBudgetTypes: calYear =>
    axios.get(`${API_BASE}/master/types`, { params: { calYear } }),
  getBudgets: (calYear, btid) =>
    axios.get(`${API_BASE}/master/budgets`, { params: { calYear, btid } }),
  getOutputs: (calYear, btid, budget) =>
    axios.get(`${API_BASE}/master/outputs`, {
      params: { calYear, btid, budget }
    }),
  getActivities: (calYear, btid, budget, oid) =>
    axios.get(`${API_BASE}/master/activities`, {
      params: { calYear, btid, budget, oid }
    }),
  getSubActivities: () => axios.get(`${API_BASE}/master/sub-activities`),
  getProjects: (calYear, aid, btid) =>
    axios.get(`${API_BASE}/master/projects`, {
      params: { calYear, aid, btid }
    }),
  getCategories: () => axios.get(`${API_BASE}/master/categories`),
  getSubCategories: cid =>
    axios.get(`${API_BASE}/master/sub-categories`, { params: { cid } }),
  getSourceMoneys: btid =>
    axios.get(`${API_BASE}/master/source-moneys`, { params: { btid } }),
  getCompanies: search =>
    axios.get(`${API_BASE}/master/companies`, { params: { search } }),
  getStrategies: () => axios.get(`${API_BASE}/master/strategies`),
  getNotes: () => axios.get(`${API_BASE}/master/notes`),
  getProtectDeps: note =>
    axios.get(`${API_BASE}/master/protect-deps`, { params: { note } }),

  // Project Balance & Project/Company CRUD
  getProjectBalance: pid => axios.get(`${API_BASE}/projects/${pid}/balance`),
  getAllProjects: calYear =>
    axios.get(`${API_BASE}/projects`, { params: { calYear } }),
  getProjectById: pid => axios.get(`${API_BASE}/projects/${pid}`),
  saveProject: data => axios.post(`${API_BASE}/projects`, data),
  deleteProject: pid => axios.delete(`${API_BASE}/projects/${pid}`),

  getAllCompanies: search =>
    axios.get(`${API_BASE}/companies`, { params: { search } }),
  saveCompany: data => axios.post(`${API_BASE}/companies`, data),
  deleteCompany: cid => axios.delete(`${API_BASE}/companies/${cid}`),

  // Master Data Tables CRUD
  getAllCategories: () => axios.get(`${API_BASE}/master/categories/all`),
  saveCategory: data => axios.post(`${API_BASE}/master/categories`, data),
  deleteCategory: cid => axios.delete(`${API_BASE}/master/categories/${cid}`),

  getAllSubCategories: cid =>
    axios.get(`${API_BASE}/master/sub-categories/all`, { params: { cid } }),
  saveSubCategory: data =>
    axios.post(`${API_BASE}/master/sub-categories`, data),
  deleteSubCategory: sid =>
    axios.delete(`${API_BASE}/master/sub-categories/${sid}`),

  getAllBudgetTypes: calYear =>
    axios.get(`${API_BASE}/master/budget-types/all`, { params: { calYear } }),
  saveBudgetType: data => axios.post(`${API_BASE}/master/budget-types`, data),
  deleteBudgetType: btid =>
    axios.delete(`${API_BASE}/master/budget-types/${btid}`),

  getAllBudgets: (calYear, btid) =>
    axios.get(`${API_BASE}/master/budgets/all`, { params: { calYear, btid } }),
  saveBudget: data => axios.post(`${API_BASE}/master/budgets`, data),
  deleteBudget: bid => axios.delete(`${API_BASE}/master/budgets/${bid}`),

  getAllSourceMoneys: btid =>
    axios.get(`${API_BASE}/master/source-moneys/all`, { params: { btid } }),
  saveSourceMoney: data =>
    axios.post(`${API_BASE}/master/source-moneys`, data),
  deleteSourceMoney: soid =>
    axios.delete(`${API_BASE}/master/source-moneys/${soid}`),

  getAllOutputs: (calYear, btid, budget) =>
    axios.get(`${API_BASE}/master/outputs/all`, {
      params: { calYear, btid, budget }
    }),
  saveOutput: data => axios.post(`${API_BASE}/master/outputs`, data),
  deleteOutput: oid => axios.delete(`${API_BASE}/master/outputs/${oid}`),

  getAllActivities: (calYear, btid, budget, oid) =>
    axios.get(`${API_BASE}/master/activities/all`, {
      params: { calYear, btid, budget, oid }
    }),
  saveActivity: data => axios.post(`${API_BASE}/master/activities`, data),
  deleteActivity: aid => axios.delete(`${API_BASE}/master/activities/${aid}`),

  getAllSubActivities: calYear =>
    axios.get(`${API_BASE}/master/sub-activities/all`, { params: { calYear } }),
  saveSubActivity: data =>
    axios.post(`${API_BASE}/master/sub-activities`, data),
  deleteSubActivity: said =>
    axios.delete(`${API_BASE}/master/sub-activities/${said}`),

  getAllNotes: () => axios.get(`${API_BASE}/master/notes/all`),
  saveNote: data => axios.post(`${API_BASE}/master/notes`, data),
  deleteNote: note => axios.delete(`${API_BASE}/master/notes/${note}`),

  getAllProtectDeps: note =>
    axios.get(`${API_BASE}/master/protect-deps/all`, { params: { note } }),
  saveProtectDep: data => axios.post(`${API_BASE}/master/protect-deps`, data),
  deleteProtectDep: id => axios.delete(`${API_BASE}/master/protect-deps/${id}`),

  // Protect Money (ใบกันเงิน)
  getProtectList: params => axios.get(`${API_BASE}/protect`, { params }),
  getProtectById: id => axios.get(`${API_BASE}/protect/${id}`),
  getProtectByNumber: number =>
    axios.get(`${API_BASE}/protect/by-number/${encodeURIComponent(number)}`),
  createProtect: data => axios.post(`${API_BASE}/protect`, data),
  updateProtect: (id, data) => axios.put(`${API_BASE}/protect/${id}`, data),
  deleteProtect: id => axios.delete(`${API_BASE}/protect/${id}`),

  // Protect Pay (การเบิกจ่ายเงิน)
  getPaymentsByNumber: number =>
    axios.get(`${API_BASE}/protect/${encodeURIComponent(number)}/payments`),
  addPayment: data => axios.post(`${API_BASE}/payments`, data),
  updatePayment: (id, data) => axios.put(`${API_BASE}/payments/${id}`, data),
  deletePayment: id => axios.delete(`${API_BASE}/payments/${id}`),
  settleProtect: number =>
    axios.post(`${API_BASE}/protect/${encodeURIComponent(number)}/settle`),

  // Reports & Dashboard
  getPaidReport: (year, btid, fromDate, toDate) =>
    axios.get(`${API_BASE}/reports/paid`, {
      params: { year, btid, fromDate, toDate }
    }),
  getPendingReport: (year, btid, fromDate, toDate) =>
    axios.get(`${API_BASE}/reports/pending`, {
      params: { year, btid, fromDate, toDate }
    }),
  getActivityReport: (year, aid) =>
    axios.get(`${API_BASE}/reports/by-activity`, { params: { year, aid } }),
  getCategoryReport: (year, aid) =>
    axios.get(`${API_BASE}/reports/by-category`, { params: { year, aid } }),
  getDashboardSummary: year =>
    axios.get(`${API_BASE}/reports/dashboard`, { params: { year } })
};
